<template>
  <template v-if="item && userDataId">
    <div class="flex gap-x-4">
      <div class="relative w-20 lg:w-36">
        <TLazyimg
          v-if="item.media.length > 0"
          :sources="getImage()"
          :alt="item.name"
          classes="block w-full h-none aspect-w-4 aspect-h-3 lg:aspect-w-16 lg:aspect-h-10"
          classes-img="block w-full h-full rounded-lg lg:rounded-xl"
        />
      </div>

      <div>
        <TText variant="semibold" size="lg" classes="mb-0">
          {{ item.name }}
        </TText>
        <TText color="gray900" classes="mb-0">
          {{ item.village.name }}, {{ item.province.name }}
        </TText>
      </div>
    </div>

    <UButton
      variant="link"
      class="mt-8 mb-6"
      size="lg"
      :padded="false"
      icon="i-heroicons-plus-small-20-solid"
      @click="goToAdminPage()"
    >
      {{ t('views.cottage-bookmarks.goToAdminPage') }}
    </UButton>
  </template>
</template>

<script setup lang="ts">
import type { CottagePage } from '~/modules/views/cottage/entities/CottagePage'

type itemType = Pick<CottagePage, 'media' | 'name' | 'village' | 'province'>

interface propsInterface {
  item: itemType
  userDataId?: string
}

const props = defineProps<propsInterface>()

// Methods
const getImage = () => {
  const filteredMedia = props.item.media.filter(item => item.type === 'PHOTO')

  return {
    url: filteredMedia[0].url,
  }
}

const goToAdminPage = () => {
  navigateTo(
    routes().travelerFavorites({
      travelerId: props.userDataId || '',
    }),
    {
      external: true,
    },
  )
}
</script>
